import { ProfileBadge } from '../../common/ProfileBadge'
import { useEffect, useState } from 'react'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { ProfessionalDetails } from './ProfessionalDetails'
import { ProfessionalCore } from './ProfessionalCore'
import { LegalAidOffice } from './LegalAidOffice'
import { RulerSeparator } from './RulerSeparator'
import {
  MemberEntityType,
  MemberProfileExtendedType,
  VALID_PEOPLE_ENTITIES,
} from 'common/types/MemberProfile'

type ProfileInformationProps = {
  profile: MemberProfileExtendedType
}

export function ProfileInformation({ profile }: ProfileInformationProps) {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    Utils.getWindowDimensions().width < 1024,
  )

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1024)
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isMobileOrTablet) {
      setIsCollapsed(false)
    }
  }, [isMobileOrTablet])

  return (
    <div
      key={profile.metadata.id}
      className='bg-white w-[320px] lg:w-[399px] h-fit rounded-xl md:rounded-3xl shadow-[0px_0px_30px_0px_rgba(39,92,141,0.2)]'
    >
      <div className='flex items-center justify-center p-6 lg:p-10 lg:w-[399px]'>
        <h3 className='text-sm lg:text-lg font-bold text-[#001A3D] text-center'>
          Important Information
        </h3>
        <button
          onClick={toggleCollapse}
          className='ml-3 p-1 cursor-pointer text-red rounded-full border-[1px] border-[#A0ABBE] bg-white text-[#405985] lg:hidden items-center justify-center'
        >
          {isCollapsed ? (
            <MdKeyboardArrowDown color='#A0ABBE' />
          ) : (
            <MdKeyboardArrowUp color='#A0ABBE' />
          )}
        </button>
      </div>
      {!isCollapsed && (
        <>
          <RulerSeparator />
          <ProfessionalCore profile={profile} />
          <RulerSeparator />
          <ProfessionalDetails profile={profile} />
          {VALID_PEOPLE_ENTITIES.includes(profile.memberEntity) && (
            <>
              <RulerSeparator />
              <div className='flex flex-col gap-2 p-10 text-center'>
                <h3 className='text-lg font-bold text-[#001A3D]'>
                  {MemberEntityType[profile.memberEntity]}
                </h3>
                <h4 className='font-medium text-base text-[#093269]'>
                  {profile.memberEntity === 'barrister'
                    ? profile.core.chamber_name
                    : profile.core.organisation_name}
                </h4>
              </div>
            </>
          )}
          {profile.professional_core.legal_aid_status && <LegalAidOffice />}
          <RulerSeparator />
          <div className='flex flex-col gap-2 p-10 items-center'>
            {['PREMIUM', 'STANDARD', 'COMMISSION'].includes(
              profile?.metadata.membership_type,
            ) && <ProfileBadge text='Promoted' variant='promoted' />}
            <p className='text-xs text-[#A0ABBE]'>{profile.metadata.id}</p>
            <a
              href={`/${profile.memberEntity.toLowerCase()}-profile-data-sources`}
              className='text-sm text-[#001A3D] pt-10 underline underline-offset-4'
            >
              Data sources
            </a>
          </div>
        </>
      )}
    </div>
  )
}
